module.exports = __webpack_public_path__ + "static/media/arrow-alt-from-right.26a51981.svg";